module.exports = __webpack_public_path__ + "img/handybee.01866ea7.png";